<template>
    <div class="about">
        <Form ref="processesForm" inline :label-width="125">
            <div class="btn-right">
                <Button type="primary" @click="showModal('add')">新增</Button>
            </div>
        </Form>
        <CTable :columns="columns" :data="queryData" :total="total"/>
        <Modal title="新增用户" width="900" v-model="showEditModal" :mask-closable="false"
               @on-cancel="handleReset('editForm')">
            <Form ref="editForm" :model="editData" :rules="editRules" inline :label-width="125">
                <Row>
                    <FormItem label="模块" prop="menuCode">
                        <Select v-model="editData.menuCode" placeholder="请选择模块">
                            <Option v-for="item in moduleList" :value="item.docCode" :key="item.docCode">
                                {{item.docName}}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="特殊" prop="special">
                        <Checkbox v-model="editData.special">是</Checkbox>
                    </FormItem>
                </Row>
                <Row>
                    <Col span="24">
                        <FormItem label="审批流说明" prop="spHeadName">
                            <Input type="textarea" v-model="editData.spHeadName" placeholder="请输入审批流说明">
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
                <div class="btn-right">
                    <Button type="primary" @click="addProcess">新增审批节点</Button>
                </div>
                <CTable :columns="editColumns" :data="editData.detailList"/>
                <FormItem prop="detailList">
                    <Input type="text" placeholder="请添加条码" style='display: none'>
                    </Input>
                </FormItem>
                <Row>
                    <Col span='8' offset='10' class="btn-groups">
                        <Button type="primary" @click="editSubmit">保存</Button>
                        <Button type="default" @click="cancelEdit">取消</Button>
                    </Col>
                </Row>
            </Form>
            <div slot="footer"></div>
        </Modal>
        <Modal title="用户明细" width="1000px" v-model="showViewModal" :mask-closable="false">
            <Form inline :label-width="125" class="form-text">
                <Row>
                    <Col span="12">
                        <FormItem label="模块编码">
                            <p class="form-static">{{viewData.menuCode}}</p>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="特殊" prop="special">
                            <Checkbox v-model="editData.special" disabled>是</Checkbox>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <FormItem label="审批流说明">
                            <p class="form-static">{{viewData.spHeadName}}</p>
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
                <CTable :columns="viewColumns" :data="viewData.detailList"/>
            </Form>
        </Modal>
    </div>
</template>

<script>
    import CTable from '@/components/CTable'
    import BtnEvent from '@/components/BtnEvent'
    import {processesRule} from '@/plugin/validateRule'
    import {moduleList} from '@/plugin/enum'

    export default {
        name: 'Process',
        mixins: [BtnEvent],
        components: {
            CTable
        },
        data() {
            return {
                roleList: [],
                moduleList: [],
                total: 0,
                showEditModal: false,
                showViewModal: false,
                edit: false,
                queryData: [],
                columns: [{
                    title: '编号',
                    key: 'id',
                    render: (h, params) => {
                        return h('div', [
                            h('a', {
                                on: {
                                    click: () => {
                                        this.showModal('view', params.row.id)
                                    },
                                }
                            }, params.row.id)
                        ])
                    }
                }, {
                    title: '模块编码',
                    key: 'menuCode'
                }, {
                    title: '说明',
                    key: 'spHeadName'
                }, {
                    title: '操作',
                    key: 'action',
                    render: (h, params) => {
                        return h('div', [
                            h('a', {
                                on: {
                                    click: () => {
                                        this.showModal('edit', params.row.id)
                                    }
                                }
                            }, '修改'),
                            h('a', {
                                on: {
                                    click: () => {
                                        this.showModal('delete', params.row.id)
                                    }
                                },
                                style: {
                                    marginLeft: '5px'
                                }
                            }, '删除')
                        ])
                    }
                }],
                editData: {
                    detailList: []
                },
                editRules: processesRule,
                editColumns: [{
                    title: '节点',
                    key: 'jdNum',
                    render: (h, params) => {
                        return h('Input', {
                            props: {
                                type: 'text',
                                value: params.row.jdNum
                            },
                            on: {
                                'on-change': (e) => {
                                    this.editData.detailList[params.index].jdNum = e.target.value
                                }
                            }
                        })
                    }
                }, {
                    title: '审批角色',
                    key: 'spCode',
                    width: 160,
                    renderHeader: (h, params) => {
                        return h('div', [
                            h('i', {
                                style: this.iconStyle
                            }, '*'),

                            h('span', {}, params.column.title)
                        ]);
                    },
                    render: (h, params) => {
                        return h('Select', {
                                props: {
                                    value: this.editData.detailList[params.index].spCode,
                                    transfer: true
                                },
                                on: {
                                    'on-change': (value) => {
                                        this.editData.detailList[params.index].spCode = value
                                    }
                                },
                            },
                            this.roleList.map(function (value) {
                                return h('Option', {
                                    props: {
                                        value: value.roleCode
                                    }
                                }, value.roleName)
                            })
                        )
                    }
                }, {
                    title: '审批节点',
                    key: 'spNum',
                    render: (h, params) => {
                        return h('Input', {
                            props: {
                                type: 'text',
                                value: params.row.spNum
                            },
                            on: {
                                'on-change': (e) => {
                                    this.editData.detailList[params.index].spNum = e.target.value
                                }
                            }
                        })
                    }
                }, {
                    title: '驳回角色',
                    key: 'bhCode',
                    width: 160,
                    renderHeader: (h, params) => {
                        return h('div', [
                            h('i', {
                                style: this.iconStyle
                            }, '*'),

                            h('span', {}, params.column.title)
                        ]);
                    },
                    render: (h, params) => {
                        return h('Select', {
                                props: {
                                    value: this.editData.detailList[params.index].bhCode,
                                    transfer: true
                                },
                                on: {
                                    'on-change': (value) => {
                                        this.editData.detailList[params.index].bhCode = value
                                    }
                                },
                            },
                            this.roleList.map(function (value) {
                                return h('Option', {
                                    props: {
                                        value: value.roleCode
                                    }
                                }, value.roleName)
                            })
                        )
                    }
                }, {
                    title: '驳回节点',
                    key: 'bhNum',
                    render: (h, params) => {
                        return h('Input', {
                            props: {
                                type: 'text',
                                value: params.row.bhNum
                            },
                            on: {
                                'on-change': (e) => {
                                    this.editData.detailList[params.index].bhNum = e.target.value
                                }
                            }
                        })
                    }
                }, {
                    title: '知会角色',
                    key: 'zhCode',
                    width: 160,
                    renderHeader: (h, params) => {
                        return h('div', [
                            h('i', {
                                style: this.iconStyle
                            }, '*'),

                            h('span', {}, params.column.title)
                        ]);
                    },
                    render: (h, params) => {
                        return h('Select', {
                                props: {
                                    value: this.editData.detailList[params.index].zhCode,
                                    transfer: true
                                },
                                on: {
                                    'on-change': (value) => {
                                        this.editData.detailList[params.index].zhCode = value
                                    }
                                },
                            },
                            this.roleList.map(function (value) {
                                return h('Option', {
                                    props: {
                                        value: value.roleCode
                                    }
                                }, value.roleName)
                            })
                        )
                    }
                }, {
                    title: '操作',
                    key: 'action',
                    render: (h, params) => {
                        return h('div', [
                            h('a', {
                                on: {
                                    click: () => {
                                        this.editData.detailList.splice(params.index, 1)
                                    }
                                },
                                style: {
                                    marginLeft: '5px'
                                }
                            }, '删除')
                        ])
                    }
                }],
                viewData: {},
                viewColumns: [{
                    title: '节点',
                    key: 'jdNum'
                }, {
                    title: '审批角色',
                    key: 'spCode',
                    minWidth: 200
                }, {
                    title: '审批节点',
                    key: 'spNum',
                    minWidth: 70,
                }, {
                    title: '驳回角色',
                    key: 'bhCode',
                }, {
                    title: '驳回节点',
                    key: 'bhNum'
                }, {
                    title: '只会角色',
                    key: 'zhCode',
                }],
                iconStyle: {
                    display: 'inline-block',
                    marginRight: '4px',
                    lineHeight: 1,
                    fontFamily: 'SimSun',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    color: '#ed4014'
                }
            }
        },
        created() {
            this.getList()
            this.init()
        },
        methods: {
            init() { // 查询表单校验
                this.$fetch('Spliu/getList', this.processes).then(res => {
                    this.queryData = res.data.list
                    this.total = res.data.list.length
                })
            },
            getList() { // 获取角色列表
                this.$fetch('AdminRole/getCodeName').then(res => {
                    this.roleList = res.data.list
                    console.log(this.roleList)
                })
                this.$fetch('Spliu/getDocList').then(res => {
                    this.moduleList = res.data.list
                })
            },
            showModal(type, id) {
                this.edit = false
                switch (type) {
                    case 'add':
                        this.showEditModal = true
                        this.editData = {
                            detailList: []
                        }
                        this.addProcess()
                        break
                    case 'edit':
                        this.$fetch('Spliu/getById', {
                            id: id
                        }).then(res => {
                            this.showEditModal = true
                            this.edit = true
                            this.editData = res.data
                            this.editData.special = this.editData.isSpecial === "1" ? true : false
                        })
                        break
                    case 'view':
                        this.$fetch('Spliu/getById', {
                            id: id
                        }).then(res => {
                            this.showViewModal = true
                            this.viewData = res.data
                            this.viewData.special = this.viewData.isSpecial === "1" ? "是" : "否"
                        })
                        break
                    case 'delete':
                        this.$Modal.confirm({
                            title: '提示',
                            content: '<p>是否确认删除？</p>',
                            onOk: () => {
                                this.$fetch('Spliu/del', {
                                    id: id
                                }).then(res => {
                                    this.$Message.info('删除成功')
                                })
                            }
                        })
                        break
                }
            },
            addProcess() {
                this.editData.detailList.push({})
            },
            editSubmit() {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.editData.isSpecial = this.editData.special ? "1" : "0"
                        this.$fetch('Spliu/save', this.editData, 'POST').then(res => {
                            this.showEditModal = false
                            this.init()
                        })
                    }
                })
            },
            cancelEdit() {
                this.showEditModal = false
                this.handleReset('editForm')
            }
        }
    }
</script>
